import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { Box, Grid, IconButton, TextField, ThemeProvider } from '@mui/material';
import { isNotBlank, isNotEmptyObject } from 'components/Common/Utils/StringUtils';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Styles from '../../../ProviderDetail.module.css';
import { FILLED_TEXTFIELD_THEME } from './CarrierConfigTheme';

const AuthenticationCredentials = ({
    updateAuthenticationCredentials,
    isEditingConfig,
    carrierConfigExist,
    carrierConfig
}) => {
    const [authenticationCredentials, setAuthenticationCredentials] = useState({});
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (
            isNotEmptyObject(carrierConfig?.authentication_credentials) &&
            isNotBlank(carrierConfig?.id) &&
            !isEditingConfig
        ) {
            setCredentialFields();
        }
    }, [carrierConfig]);

    useEffect(() => {
        if (isNotEmptyObject(carrierConfig?.authentication_credentials)) {
            setCredentialFields();
        }
    }, [isEditingConfig]);

    const setCredentialFields = () => {
        setAuthenticationCredentials(carrierConfig?.authentication_credentials);
    };

    const handleChange = (e) => {
        const { name, value } = e.target ?? {};
        setAuthenticationCredentials((prev) => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        updateAuthenticationCredentials(authenticationCredentials);
    }, [authenticationCredentials]);

    return (
        <ThemeProvider theme={FILLED_TEXTFIELD_THEME}>
            <Box style={{ paddingTop: 5, paddingBottom: 5 }}>
                <div className={Styles.providerDetailsPanelHeader} style={{ padding: '8px 0' }}>
                    Authentication Credentials *
                </div>
                <Grid container spacing={1} alignItems="center">
                    <Grid item xs={6}>
                        <TextField
                            label="Username"
                            variant="filled"
                            fullWidth
                            name="username"
                            value={authenticationCredentials.username || ''}
                            onChange={handleChange}
                            disabled={!isEditingConfig && carrierConfigExist}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <TextField
                                label="Password"
                                variant="filled"
                                type={showPassword ? 'text' : 'password'}
                                fullWidth
                                name="password"
                                value={authenticationCredentials.password || ''}
                                onChange={handleChange}
                                disabled={!isEditingConfig && carrierConfigExist}
                            />
                            <IconButton
                                aria-label={showPassword ? 'Hide password' : 'Show password'}
                                size="small"
                                onClick={() => setShowPassword((current) => !current)}
                                onMouseDown={(event) => event.preventDefault()}
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </ThemeProvider>
    );
};

export default withRouter(connect()(AuthenticationCredentials));
